import { Expose } from "class-transformer";
import type { CmsProductDto } from "../../../../services/ApiClientBonusxCmsRepository/dtos/cms-product/cms-product.dto";
import { ProductDto } from "../product/product.dto";
import type { IProductWithCmsDataDto } from "./product-with-cms-data.dto.interface";

export class ProductWithCmsDataDto extends ProductDto implements IProductWithCmsDataDto {
  @Expose()
  cms!: CmsProductDto;
}
